import {GroupAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/GroupAIP';
import {NewYorkAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/NewYorkAIP';
import {OrdinaryAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/OrdinaryAIP';

export type AIP = OrdinaryAIP | GroupAIP | NewYorkAIP;

type ExhaustiveAIPOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryAIP) => TReturn;
  Group: (group: GroupAIP) => TReturn;
  NewYork: (newYork: NewYorkAIP) => TReturn;
};

type PartialAIPOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryAIP) => TReturn;
  Group?: (group: GroupAIP) => TReturn;
  NewYork?: (newYork: NewYorkAIP) => TReturn;
  _: (app: AIP) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: AIPByTypeOptions<TReturn>
): options is ExhaustiveAIPOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type AIPByTypeOptions<TReturn> = PartialAIPOptionsByType<TReturn> | ExhaustiveAIPOptionsByType<TReturn>;

export const matchAIPByType = <TReturn>(options: AIPByTypeOptions<TReturn>) => (app: AIP): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryAIP':
    case 'ValidOrdinaryAIP':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupAIP':
    case 'ValidGroupAIP':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkAIP':
    case 'ValidNewYorkAIP':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidAIP = (aip: AIP) =>
  aip.key === 'ValidOrdinaryAIP' || aip.key === 'ValidGroupAIP' || aip.key === 'ValidNewYorkAIP';
